import React from "react";
import "./Blog.css";
import One from "./Images/1.png";
import Two from "./Images/2.png";
import Three from "./Images/3.png";
import Four from "./Images/4.png";
import Item from "./Item";
import Latest from "./Latest";

const Blog = () => {
  return (
    <div className="blogs">
      <div>
        <div className="body">
          <div className="header">Blogs</div>
          <div className="items">
            <Item
              desc="Kiran / November 30, 2024"
              title="What is the CDR Writing Process for Engineers Australia?"
              img={Four}
              link="/blog/What-is-the-CDR-Writing-Process-for-Engineers-Australia?"
            />
            <Item desc="Kiran / November 30, 2024" title="How can you get an Australian Onshore Visa?" img={Three} link="/blog/How-can-you-get-an-Australian-Onshore-Visa?" />
            <Item
              desc="Kiran / November 30, 2024"
              title="Your Complete Guide to the KA02 Knowledge Assessment (2024 Edition)"
              img={Two}
              link="/blog/Your-Complete-Guide-to-the-KA02-Knowledge-Assessment-(2024-Edition)"
            />
            <Item
              desc="Kiran / November 30, 2024"
              title="List of Courses that Helps to Migrate Engineers to Australia in 2023."
              img={One}
              link="/blog/List-of-Courses-that-Helps-to-Migrate-Engineers-to-Australia-in-2023."
            />
          </div>
        </div>
        <Latest />
      </div>
    </div>
  );
};

export default Blog;
